//from https://fmennen.de/post/comparing-two-objects-in-java-script-finding-differences

export function deepCompare(a: any, b: any): boolean {
  //console.log('deepCompare: testing root', a, b);
  if (a === b) return true;

  //console.log('deepCompare: testing types', a, b);
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  //console.log('deepCompare: testing length', a, b);
  if (keysA.length !== keysB.length) return false;

  //console.log('deepCompare: testing keys', keysA, keysB);
  for (const key of keysA) {
    if (!keysB.includes(key) || !deepCompare(a[key], b[key])) {
      return false;
    }
    if (Array.isArray(a[key]) && Array.isArray(b[key])) {
      if (a[key].length !== b[key].length) {
        return false;
      }
      for (let i = 0; i < a[key].length; i++) {
        if (!deepCompare(a[key][i], b[key][i])) {
          return false;
        }
      }
    }
  }

  return true;
}
